import { render, staticRenderFns } from "./SaisieAnalysePatient.vue?vue&type=template&id=be5fe7a2"
import script from "./SaisieAnalysePatient.vue?vue&type=script&lang=js"
export * from "./SaisieAnalysePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports